<div *ngIf="isLoading" class="loading-container">
  <qai-loading size="medium"></qai-loading>
</div>

<div class="certification-content" *ngIf="!isLoading && isTranslationLoaded">
    <qai-item-grid
      gap="24px"
      minItemWidth="280px"
      repeatCount="auto-fit"
      class="summary-grid"
    >
      <div class="summary-card">
        <div class="card-label">{{ 'reportingV2.CERTIFIED_ON_FIRST_TRY' | transloco }}</div>
        <div class="card-value">
          <span class="value-bold">{{ localeService.formatPercentage(certifiedOnFirstTryPercentage, localeService.getDecimalPlaces(certifiedOnFirstTryPercentage, 2)) }}</span>
          <span class="value-text">{{ 'reportingV2.OF_THE_TIME' | transloco }}</span>
        </div>
      </div>
      
      <div class="summary-card">
        <div class="card-label">{{ 'reportingV2.AVERAGE_CERTIFICATION_SCORE' | transloco }}</div>
        <div class="card-value">
          <span class="value-bold">{{ localeService.formatNumber(averageCertificationScore, localeService.getDecimalPlaces(averageCertificationScore)) }}</span>
        </div>
      </div>
      
      <div class="summary-card">
        <div class="card-label">{{ 'reportingV2.TOTAL_TIME_CERTIFYING' | transloco }}</div>
        <div class="card-value">
          <span class="value-bold">{{ totalCertificationTime }}</span>
        </div>
      </div>
    </qai-item-grid>

    <div #tableContainer>
      <qai-table
        [headers]="headers"
        [data]="tableData"
        [striped]="false"
        [currentPage]="currentPage"
        [showPagination]="true"
        [pageSize]="3"
        [currentPage]="1"
        [initialSortColumn]="initialSortColumn"
        [initialSortDirection]="initialSortDirection"
        (pageChanged)="onPageChanged($event)"
        [noDataMessage]="'reportingV2.NO_ASSIGNMENTS' | transloco"
        [previousLabel]="'reportingV2.PAGINATION_PREVIOUS' | transloco"
        [nextLabel]="'reportingV2.PAGINATION_NEXT' | transloco"
      ></qai-table>
    </div>
  </div>
